import { useEffect, useState } from "react";
import { Form, KeyStringValue, KeyValue } from "../interfaces";

export default function useAppStateToFormChanges<T extends Form>(
  filters: KeyValue,
  search: KeyStringValue,
  setForm: (func: (prevState: T) => T) => void,
) {
  const [prevForm, setPrevForm] = useState({});

  useEffect(() => {
    // This is to update the form when the query filters are changed outside the form, which happens due to the usage
    // of the search pills
    function reducer(obj: KeyValue) {
      return Object.keys(obj).reduce((map: any, key: string) => {
        map[key] = obj[key];
        return map;
      }, {});
    }

    setForm((prevState: T) => {
      const formWithFilterValues: KeyValue = reducer(filters);
      const formWithSearchValues: KeyValue = reducer(search);

      const newState: T = {
        ...prevState,
        ...formWithFilterValues,
        ...formWithSearchValues,
      };

      setPrevForm(newState);

      return newState;
    });
  }, [filters, search, setForm, setPrevForm]);

  return { prevForm, setPrevForm };
}
